/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClientInfoView } from '../../models/client-info-view';

export interface GetAllClients$Params {
}

export function getAllClients(http: HttpClient, rootUrl: string, params?: GetAllClients$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ClientInfoView>>> {
  const rb = new RequestBuilder(rootUrl, getAllClients.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ClientInfoView>>;
    })
  );
}

getAllClients.PATH = '/api/v1/ChangeNotifications/Clients';
